import { Injectable } from '@angular/core';
import { RCSInteractionDetails } from '../models/rcs-interaction-details.model';

@Injectable({ providedIn: 'root' })
export class RCSInteractionDetailsAdapter {
  adapt(item: any): RCSInteractionDetails {
    const interaction = new RCSInteractionDetails();
    interaction.interactionID = item.InteractionID || item.interactionID;
    interaction.interactionType = item.InteractionType || item.interactionType;
    interaction.interactionDate = (item.InteractionDate || item.interactionDate) ? new Date(item.InteractionDate || item.interactionDate) : null;
    interaction.suggestionText = item.SuggestionText || item.suggestionText;
    interaction.suggestionType = item.SuggestionType || item.suggestionType;
    interaction.number = item.Number || item.number;
    interaction.contactID = item.ContactID || item.contactID;
    interaction.totalCount = item.TotalCount || item.totalCount;
    return interaction;
  }
}
